var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDeleteRed = function SvgDeleteRed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 5.83337L1.99967 19.1667H11.9997L13.6663 5.83337H0.333008ZM2.22098 7.50004L3.47098 17.5H10.5284L11.7784 7.50004H2.22098Z",
    fill: "#FF3748"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 2.5H13.6663V4.16667H0.333008V2.5Z",
    fill: "#FF3748"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 0.833374H8.66634V2.50004H5.33301V0.833374Z",
    fill: "#FF3748"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 8.94019L6.48729 15.5815L4.82696 15.7267L4.24593 9.08545L5.90625 8.94019Z",
    fill: "#FF3748"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5459 15.5814L8.12694 8.94012L9.78726 9.08538L9.20622 15.7267L7.5459 15.5814Z",
    fill: "#FF3748"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_red.51729e52.svg";
export { ForwardRef as ReactComponent };